import { createContext } from 'react';
var UserContext = createContext({ setUserSettings: function () { } });
export default UserContext;
